import React, { useState } from "react";
import type { NavItem } from "../../data/landingData";
import { cn } from "../../utils/cn";

export default function Navbar({
    brand = "BotX",
    items,
    primaryCta = { label: "Dodaj bota", href: "https://discord.com/oauth2/authorize" },
    secondaryCta = { label: "Dashboard", href: "#" },
}: {
    brand?: string;
    items: NavItem[];
    primaryCta?: { label: string; href: string };
    secondaryCta?: { label: string; href: string };
}) {
    const [open, setOpen] = useState(false);

    return (
        <header className="sticky top-0 z-50 border-b border-white/10 bg-black/20 backdrop-blur-xl">
            <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
                <a href="#" className="flex items-center gap-2">
                    <div className="h-9 w-9 rounded-xl border border-white/10 bg-white/5" />
                    <span className="text-sm font-semibold tracking-wide text-white">{brand}</span>
                </a>

                <nav className="hidden items-center gap-6 md:flex">
                    {items.map((it) => (
                        <a
                            key={it.href}
                            href={it.href}
                            className="text-sm text-white/70 hover:text-white transition"
                        >
                            {it.label}
                        </a>
                    ))}
                </nav>

                <div className="hidden items-center gap-2 md:flex">
                    <a
                        href={secondaryCta.href}
                        className="rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-sm text-white/80 hover:bg-white/10 transition"
                    >
                        {secondaryCta.label}
                    </a>
                    <a
                        href={primaryCta.href}
                        className={cn(
                            "rounded-xl px-3 py-2 text-sm font-medium text-black",
                            "bg-white hover:bg-white/90 transition"
                        )}
                    >
                        {primaryCta.label}
                    </a>
                </div>

                <button
                    className="md:hidden rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-sm text-white/80"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Menu"
                >
                    Menu
                </button>
            </div>

            {open ? (
                <div className="md:hidden border-t border-white/10 bg-black/30 backdrop-blur-xl">
                    <div className="mx-auto max-w-6xl px-4 py-4 sm:px-6">
                        <div className="flex flex-col gap-3">
                            {items.map((it) => (
                                <a
                                    key={it.href}
                                    href={it.href}
                                    className="text-sm text-white/80 hover:text-white"
                                    onClick={() => setOpen(false)}
                                >
                                    {it.label}
                                </a>
                            ))}
                            <div className="mt-2 flex gap-2">
                                <a
                                    href={secondaryCta.href}
                                    className="flex-1 rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-sm text-white/80"
                                >
                                    {secondaryCta.label}
                                </a>
                                <a
                                    href={primaryCta.href}
                                    className="flex-1 rounded-xl bg-white px-3 py-2 text-sm font-medium text-black text-center"
                                >
                                    {primaryCta.label}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </header>
    );
}
